import { createFileRoute } from '@tanstack/react-router';
import { InventoryPage } from '@/components/inventory/inventory-page';

export const Route = createFileRoute('/inventory')({
  component: InventoryPage,
});
